const testIds = {
  codeBlockCopyButton: 'code block copy button',
  copyButton: 'copy button',
  feedbackButton: 'feedback button',
  feedbackSendBox: 'feedback sendbox',
  sendBoxAttachmentBar: 'send box attachment bar',
  sendBoxDropZone: 'send box drop zone',
  sendBoxAttachmentBarItem: 'send box attachment bar item',
  sendBoxAttachmentBarItemDeleteButton: 'send box attachment bar item delete button',
  sendBoxMicrophoneButton: 'send box microphone button',
  sendBoxSpeechBox: 'send box speech box',
  sendBoxTextBox: 'send box text area',
  suggestedActionButton: 'suggested action button',
  typingIndicator: 'typing indicator',
  viewCodeButton: 'view code button'
};

export default testIds;
